import { useMemo } from 'react';
import { useEditableTranslation } from '#common/i18n/edit-mode.tsx';
import { type TranslateFunc } from '#common/i18n/types';
import { OrderCard } from './OrderCard';
import { type RecordingRow } from './Recording';
import { useRecordingContext } from './RecordingContext';
import { Recordings } from './Recordings';
import { Section } from './Section';
import { SectionTitle } from './SectionTitle';

interface Props {
    availableUses: {
        id: string;
        medium: { name: string; titleEn: string | null; titleDe: string | null };
        basePrice: number;
        basePriceCharacters: number;
    }[];
    selectedUses: string[];
    currency: string;
}

function createPlaceholderRecordings(t: TranslateFunc): RecordingRow[] {
    return [ {
        isPlaceholder: true,
        takes: [ { isPlaceholder: true, text: t('no-recordings-yet') } ]
    } ];
}

export function Checkout({ availableUses, selectedUses, currency }: Props) {
    const { t, rawT } = useEditableTranslation('checkout');
    const { recordings } = useRecordingContext();
    const placeholderRecordings = useMemo(() => createPlaceholderRecordings(rawT), [ rawT ]);
    return (
        <Section>
            <SectionTitle color='blue' text={t('header')} />
            <div className='flex gap-12 flex-col lg:flex-row'>
                <div className='grow min-w-0'>
                    <p className='text-lg text-slate-600 mb-4'>{t('description')}</p>
                    <Recordings recordings={recordings.length ? recordings : placeholderRecordings} />
                </div>
                <div className='shrink-0 self-center lg:self-auto'>
                    <OrderCard
                        allowedMediums={availableUses.filter(x => selectedUses.indexOf(x.id) !== -1)}
                        currency={currency}
                    />
                </div>
            </div>
        </Section>
    );
}
